var defaultAllowedEnvironments = ['test', 'development', 'dev'];
var environment = process.env.NODE_ENV;

var shouldShowForEnvironment = function shouldShowForEnvironment(allowedEnvironments) {
  if (allowedEnvironments === void 0) {
    allowedEnvironments = defaultAllowedEnvironments;
  }

  return typeof environment === 'string' ? allowedEnvironments.includes(environment) : false;
};

export { shouldShowForEnvironment as default };
